export class CurrentIncomeItem{
  currentIncomeMonthlyTotalAmount: number=0;
  employmentIncomeIndicator: boolean = false;
  incomeTypeDesc: string="";
  incomeType: number= 0;
}
